import { Fragment, useCallback } from 'react';
import Input from '../../../form/Input';

/**
 * @author taulmax
 * @date 2024.10.11
 * @description 상품 등록 페이지 - 상품 금액
 */
const PCost = ({
  pRef,
  pCost,
  setPCost,
}: {
  pRef: React.RefObject<HTMLInputElement>;
  pCost: string;
  setPCost: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const onChangePCost = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.replace(/[^0-9]/g, ''); // 숫자 이외의 문자 제거
      if (value === '') {
        setPCost(''); // 빈 값일 때 그대로 유지
      } else {
        const formattedValue = Number(value).toLocaleString(); // 천단위 콤마 추가
        setPCost(formattedValue);
      }
    },
    [setPCost]
  );

  return (
    <div>
      <span style={{ fontSize: '13px', color: '#6b7280', marginBottom: '4px', display: 'block' }}>기본 가격</span>
      <Input
        inputRef={pRef}
        value={pCost}
        onChange={onChangePCost}
        textAlign="left"
        placeholder="기본 가격 입력"
        suffix="₩"
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default PCost;
